import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})


export class CCRevenueHelperService {

    public changeDetection = new BehaviorSubject<boolean>(false);

    constructor() { }


    
    /**
     * Triggers a change detection event by emitting a value through the `changeDetection` subject.
     *
     * @param value - A boolean indicating whether to trigger change detection. Defaults to `true`.
     */
    triggerChangeDetection(value: boolean = true): void {
        this.changeDetection.next(value);
    }




    getChangeDetectionObservable() {
        return this.changeDetection.asObservable();
    }
}